import produce from "immer";

import { contextConstants } from "context/constants";

export const initialState = {
  jobOpp: [],
  jobOpps: [],
  loadingJobOpp: true,
  isLoading: true,
  companyFilter: "All",
  companyNames: [],
  jobTypeFilter: "All",
  jobTypes: [],
};

export const reducer = produce((draft, action) => {
  const { type, payload } = action;

  switch (type) {
    case contextConstants.jobs.JOB_OPP_LOADED: {
      draft.jobOpp = payload.jobOpp;
      draft.loadingJobOpp = false;
      break;
    }

    case contextConstants.jobs.JOB_OPP_CLEARED: {
      draft.jobOpp = {};
      draft.loadingJobOpp = true;
      break;
    }

    case contextConstants.jobs.JOB_OPPS_LOADING: {
      draft.isLoading = payload.isLoading;
      break;
    }

    case contextConstants.jobs.JOB_OPPS_LOADED: {
      draft.jobOpps = payload.jobOpps;
      draft.isLoading = false;
      break;
    }

    case contextConstants.jobs.JOB_TYPES_LOADED: {
      draft.jobTypes = payload.jobTypes;
      break;
    }

    case contextConstants.jobs.COMPANY_NAMES_LOADED: {
      draft.companyNames = payload.companyNames;
      break;
    }

    case contextConstants.jobs.COMPANY_FILTER_UPDATED: {
      draft.companyFilter = payload.companyFilter;
      break;
    }

    case contextConstants.jobs.JOB_TYPE_FILTER_UPDATED: {
      draft.jobTypeFilter = payload.jobTypeFilter;
      break;
    }

    case contextConstants.jobs.JOB_FILTERS_CLEARED: {
      draft.companyFilter = "All";
      draft.jobTypeFilter = "All";
      break;
    }

    default:
      break;
  }
});
